<template>
  <div>
    <v-list v-if="projects.length" dense nav color="transparent">
      <project-list-item
        v-for="project in projects"
        :key="project.id"
        :project="project"
        :current-id="currentId"

      />
    </v-list>
    <p v-else class="text-center overline grey--text">Aucun Chantier</p>
  </div>
</template>

<script>
import ProjectListItem from './ProjectListItem.vue'
export default {
  name: 'ProjectList',
  components: { ProjectListItem },
  props: {
    projects: {
      type: Array,
      required: true,
    },
    currentId: {
      type: [String, Number],
      default: null,
    },
  },
}
</script>
